/* Y2K hızlı sepete ekle (brief 3.3)
   - Tek varyant: "Sepete ekle" direkt ekler.
   - Tek seçenekli çoklu varyant: "Beden seç" pill'leri açar, pill'e dokunmak ekler.
   Dawn'ın cart-drawer / cart-notification bileşeni varsa onun renderContents
   akışı kullanılır (drawer açılır, sayaç güncellenir); yoksa cart-icon-bubble
   section'ı yeniden çizilir. Sonuç aria-live bölgesine de yazılır. */
(() => {
  const LIVE_ID = 'y2k-qa-live';

  function liveRegion() {
    let el = document.getElementById(LIVE_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = LIVE_ID;
      el.className = 'visually-hidden';
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    return el;
  }

  class Y2KQuickAdd extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-toggle]');
        if (toggle) {
          this.togglePills(toggle);
          return;
        }
        const btn = e.target.closest('[data-variant-id]');
        if (btn && !btn.disabled) this.add(btn);
      });
    }

    togglePills(toggle) {
      const pills = this.querySelector('.y2k-qa__pills');
      if (!pills) return;
      const willOpen = pills.hasAttribute('hidden');
      pills.toggleAttribute('hidden', !willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
    }

    say(msg) {
      liveRegion().textContent = msg;
    }

    async add(btn) {
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'EKLENİYOR…';

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = new FormData();
      body.append('id', btn.dataset.variantId);
      body.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      try {
        const res = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body,
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || 'Eklenemedi');

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          await this.refreshBubble();
        }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'y2k-quick-add', cartData: data });
        }

        const pills = this.querySelector('.y2k-qa__pills');
        const toggle = this.querySelector('[data-toggle]');
        if (pills && toggle) {
          pills.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
        btn.textContent = 'EKLENDİ ✓';
        this.say('Ürün sepete eklendi');
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1600);
      } catch (err) {
        btn.textContent = 'EKLENEMEDİ';
        this.say(err.message || 'Ürün sepete eklenemedi');
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2200);
      }
    }

    async refreshBubble() {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      const res = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`);
      const sections = await res.json();
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : sections['cart-icon-bubble'];
    }
  }

  if (!customElements.get('y2k-quick-add')) customElements.define('y2k-quick-add', Y2KQuickAdd);
})();
